module.exports = __webpack_public_path__ + "img/1.a71c9802.png";